import { render, staticRenderFns } from "./r-second-panel.vue?vue&type=template&id=61f180ef"
import script from "./r-second-panel.vue?vue&type=script&lang=js"
export * from "./r-second-panel.vue?vue&type=script&lang=js"
import style0 from "./r-second-panel.vue?vue&type=style&index=0&id=61f180ef&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports